export const ActionTypes = {
  LOADING: "CLONE_DECISION_LOADING",
  ERROR: "CLONE_DECISION_ERROR",
  SUCCESS: "CLONE_DECISION_SUCCESS",
};
